import React, { Component } from "react";
import { connect } from "react-redux";

import { withRouter } from "utilities/withRouter";
import quote from "services/quote/quote.service";
import { getCustomQuote } from "services/customQuote/customQuote.service";
import getSfdc from "services/sfdc/sfdc.service";
import commonUtilities from "utilities/common";

import CustomizeQuoteWizard from "./customizeQuoteWizard";

import "./customizeQuote.css";

class CustomizeQuote extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sfdc: this.props.sfdc || {}
        };
    }

    componentDidMount() {
        this.initCustomQuote();
    }
        
    initCustomQuote =  async () => {
        
        if (this.props.params) {
            let { quoteNumber } = this.props.params;
            // init custom quote store
            this.props.dispatch({ type: "CUSTOM_QUOTE_RESET" });
            // load quote, reform it to custom quote object
            this.props.showLoadingSpinner(true);
            const customQuoteResponse = await this.props.dispatch(quote.getCustomQuote(quoteNumber));
            const response = this.props.dispatch(getCustomQuote(customQuoteResponse));
            if(response.type === "SET_CUSTOM_QUOTE_SUCCESS"){
                const { sfdc } = this.state;
                if(sfdc?.data?.statusCode !== 200) {
                    const { sfdcLeadNumber } = response?.payload?.data;
                    if(sfdcLeadNumber) {
                        await this.props.dispatch(getSfdc(sfdcLeadNumber));
                    }
                }
            }
            this.props.showLoadingSpinner(false);
        }
    };

    componentWillUnmount() {
        this.props.dispatch({ type: "QUOTE_RESET" });
        this.props.dispatch({ type: "CUSTOM_QUOTE_RESET" });
        this.props.dispatch({ type: "GET_CUSTOM_QUOTE_PDF_RESET" });
    }

    render() {

        const isAgent = commonUtilities.isAgent();

        return (
            <div className="row margin-bottom-4x review-group-responsive">
                <div className="row margin-top-1x">
                    {isAgent ? <CustomizeQuoteWizard/> : null}
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sfdc: state.sfdc
});

export default connect(mapStateToProps)(withRouter(CustomizeQuote));